import './candidateCertificates.css';
import { Col, Row } from 'react-bootstrap';
import { generateColors } from '../../../../utils/colorUtilsClientInfo';
import CertificationIcon from '../../../../assets/images/ic_certificates.png';

const CandidateCertificationInfoPanel = ({ colorSeed, certificate }) => {
  const colours = generateColors(colorSeed);
  const safeCertificate = certificate || {};

  const formatDate = (dateValue) => {
    if (!dateValue) return '';
    const date = new Date(dateValue);
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  };

  return (
    <Row className="certificateInfoContainer mt-1 d-flex ">
      <Col xs={2} sm={2} lg={1} className="d-flex justify-content-center ">
        <span className="rounded-span" style={{ backgroundColor: colours.backgroundColor, color: colours.color }}>
          <img src={CertificationIcon} alt="Certifications" className="profile-work-experience-nav-icon" />
        </span>
      </Col>
      <Col xs={10} sm={10} lg={11}>
        <Row>
          <Col xs={12}>
            <span className="title pt-1">{safeCertificate.title || ''}</span>
            {/* <span className="sub-title"> <span>at</span> {safeCertificate.universityOrCollege || ''}</span> */}
            {safeCertificate.universityOrCollege && (
              <span className="sub-title"> at {safeCertificate.universityOrCollege}</span>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {/* <span className="sub-title1">
              {formatDate(safeCertificate.startDate)} - {formatDate(safeCertificate.endDate)}
            </span> */}
            <span className="sub-title1">
              {safeCertificate.startDate || safeCertificate.endDate
                ? `${formatDate(safeCertificate.startDate)}${safeCertificate.startDate && safeCertificate.endDate ? ' - ' : ''}${formatDate(safeCertificate.endDate)}`
                : ''}
            </span>

          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default CandidateCertificationInfoPanel;